
<template>
  <div>
    <div class="cominfo-header">企业中心 <span>/</span>
      <span>学员中心</span><span>/</span>
      <span>
        <router-link to="/Company/UserList">学员列表</router-link>
      </span><span>/</span><span>学员档案</span>
    </div>

    <div class="archivesInfo disFlex">
      <div class="archivesBlock1">
        <div class="archivesInfo-header">
          学员资料
        </div>
        <div class="archivesInfo-content">
          <div class="disFlex">
            <div>
              <img :src="getTxurl(userInfo)"
                style="width: 58px;height: 70px;border-radius: 4px;margin-right: 12px;" />
            </div>
            <div>
              <div class="disFlex unserLine" style="height: 20px;margin-bottom: 10px;">
                <div class="userLabel" style="width: auto;">姓名：</div>
                <div class="userCont">{{userInfo.realName}}</div>
              </div>
              <div class="editBtn" @click="toEdit" v-if="userInfo.id!=currentUser.id">编辑资料</div>
            </div>
          </div>

          <div class="disFlex unserLine">
            <div class="userLabel">学员ID：</div>
            <div class="userCont">{{userInfo.stuid}}</div>
          </div>
          <div class="disFlex unserLine">
            <div class="userLabel">性 别：</div>
            <div class="userCont">{{userInfo.sex}}</div>
          </div>
          <div class="disFlex unserLine">
            <div class="userLabel">年 龄：</div>
            <div class="userCont">{{userInfo.age}}</div>
          </div>
          <div class="disFlex unserLine">
            <div class="userLabel">在职状态：</div>
            <div class="userCont">{{userInfo.state=='1'?'在职':'离职'}}</div>
          </div>
          <div class="disFlex unserLine">
            <div class="userLabel">联系方式：</div>
            <div class="userCont">{{userInfo.phone}}</div>
          </div>
          <div class="disFlex unserLine">
            <div class="userLabel">身份证号：</div>
            <div class="userCont">{{userInfo.card}}</div>
          </div>
          <div class="disFlex unserLine">
            <div class="userLabel">创建时间：</div>
            <div class="userCont">2021-12-12 23:00</div>
          </div>

        </div>
      </div>
      <div class="archivesBlock2">
        <div class="archivesInfo-header">
          <div>近期学习情况</div>
          <div class="disFlex">
            <div :class="'timeBlock'+(lineForm.timeType=='0'?' active':'')" @click="changeTime(0)">今日</div>
            <div :class="'timeBlock'+(lineForm.timeType=='1'?' active':'')" @click="changeTime(1)">本周</div>
            <div :class="'timeBlock'+(lineForm.timeType=='2'?' active':'')" @click="changeTime(2)">本月</div>
            <div :class="'timeBlock'+(lineForm.timeType=='3'?' active':'')" @click="changeTime(3)">全年</div>
            <div>
              <el-date-picker v-model="lineForm.time" style="width: 256px;" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" @change="getZxt">
              </el-date-picker>
            </div>
          </div>
        </div>
        <div class="archivesInfo-content">
          <div id="learingCont" style="height: 300px;"></div>
        </div>
      </div>
    </div>

    <div class="archivesInfo" style="background-color: #fff;border-radius: 4px;padding: 20px;">
      <el-tabs v-model="activeName" @tab-click="handleClick" v-if="userInfo.id">
        <el-tab-pane label="学习记录" name="first">
          <stady-list :creator="userInfo.id" :wjSrc="wjSrc"/>
        </el-tab-pane>
        <el-tab-pane label="考试记录" name="four">
          <kaoshi-list :creator="userInfo.id" :wjSrc="wjSrc"/>
        </el-tab-pane>
        <el-tab-pane label="错题记录" name="second">
          <error-list :creator="userInfo.id" :wjSrc="wjSrc"/>
        </el-tab-pane>
        <el-tab-pane label="所获证书" name="third">
          <card-list  :creator="userInfo.id" :wjSrc="wjSrc"/>
        </el-tab-pane>
      </el-tabs>
    </div>

  </div>
</template>

<script>
  import {
    format
  } from '../../assets/js/common.js'
  import * as echarts from 'echarts';
  import StadyList from '../common/StadyList';
  import ErrorList from '../common/ErrorList';
  import CardList from '../common/CardList';
  import KaoshiList from '../common/KaoshiList';
  export default {
    props: ['collapse', 'wjSrc', 'currentUser'],
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('联系方式不能为空！'));
        } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
          callback(new Error('联系方式有误，请重新输入！'));
        } else {
          callback();
        }
      };
      return {
        circleUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
        lineForm: {
          time: ['2021-07-03', '2021-07-13'],
          timeType: 1
        },
        tableData: {
          rows: [],
          total: 0
        },
        activeName: 'first',
        userInfo:{},
        txnanUrl: require('@/assets/images/notxnan.png'),
        txnvUrl: require('@/assets/images/notxnv.png'),
        txnoUrl: require('@/assets/images/nosex.png'),
      }
    },
    methods: {
      getTxurl: function(item) {
        if (item.avatarurl) {
          return this.wjSrc + item.avatarurl
        } else if (item.sex == '女') {
          return this.txnvUrl
        } else if (item.sex == '男') {
          return this.txnanUrl
        } else {
          return this.txnoUrl
        }
      },
      getData: function(id) {
        this.$axios.get('/system/user_role/COM_USER_AQKT/load.htm?id=' + id).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.userInfo = data.data;
            this.isAdamin=false;

          } else {
            this.$message.error(data.message);
          }
        })
      },
      getZxt: function() {
        var params={
          startime:this.lineForm.time[0],
          endtime:this.lineForm.time[1],
          creator:this.$route.query.id
        }
        this.$axios.get('/kt/learnfile/getlearn.htm?'+this.$qs.stringify(params)).then(res => {
          var data = res.data;
          var daylist=[];
          var valList=[];
          data.map((item)=>{
            daylist.push(item.day);
            valList.push(item.studytimes);
          });
          var option = {
            tooltip:{
              show:true
            },
            xAxis: {
              type: 'category',
              data: daylist
            },
            yAxis: {
              type: 'value'
            },
            grid: {
              x: 30,
              bottom: 25,
              top: 20,
              right: 0
            },
            series: [{
              data: valList,
              type: 'line',
              color: '#1890FF'
            }]
          };

          var myChart = echarts.init(document.getElementById('learingCont'));
          myChart.setOption(option);
        })

      },
      handleClick: function() {

      },
      changeTime:function(timeType){
        this.$set(this.lineForm,'timeType',timeType);
        var start=new Date();
        var end=new Date();
        var year=start.getFullYear();
        // 今天
        if(timeType==0){
          this.$set(this.lineForm, 'time', [format('YYYY-MM-DD',start), format('YYYY-MM-DD',start)])
        }else if(timeType==1){
          // 本周
          var week=start.getDay();//获取今天是周几
          start.setTime(start.getTime() - 3600 * 1000 * 24 * (week-1));
          end.setTime(end.getTime() + 3600 * 1000 * 24 * (7-week));
          this.$set(this.lineForm, 'time', [format('YYYY-MM-DD',start), format('YYYY-MM-DD',end)]);
        }else if(timeType==2){
          // 本月
          // 获取本月的天数
          var month=start.getMonth()+1;
          var days=new Date(year,month,0).getDate();
          this.$set(this.lineForm, 'time', [year+'-'+(month>9?month:'0'+month)+'-01', year+'-'+(month>9?month:'0'+month)+'-'+days]);
        }else if(timeType==3){
          // 本年
          this.$set(this.lineForm, 'time', [year+'-01-01', year+'-12-31']);
        }
        this.getZxt();
      },
      toEdit: function(id) {
        this.$router.push('/Company/UserInfo?id=' + this.$route.query.id);
      },
    },
    created: function() {
      if (this.$route.query.id) {
        this.getData(this.$route.query.id)
      }
    },
    mounted: function() {
      this.changeTime(1);
    },
    watch: {
    },
    components: {
      StadyList,
      ErrorList,
      CardList,
      KaoshiList
    }
  }
</script>
<style>
  .archivesInfo {
    opacity: 1;
    margin-top: 20px;
  }

  .archivesBlock1 {
    flex: 1;
    border-radius: 4px;
    background-color: #fff;
    height: 385px;
  }

  .archivesBlock2 {
    flex: 2;
    margin-left: 20px;
    border-radius: 4px;
    background-color: #fff;
    height: 385px;
  }

  .archivesInfo-header {
    height: 53px;
    border-bottom: 1px solid #efefef;
    padding: 0 20px;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #333333;
    font-size: 16px;
    font-weight: 500;
  }

  .timeBlock {
    margin-right: 24px;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.65);
    line-height: 36px;
    font-weight: 400;
  }

  .timeBlock.active {
    color: #1890FF;
  }

  .unserLine {
    height: 30px;
    align-items: center;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
  }

  .userLabel {
    width: 70px;
    color: rgba(0, 0, 0, 0.85);
  }

  .userCont {
    color: rgba(0, 0, 0, 0.65);
  }

  .editBtn {
    width: 96px;
    height: 32px;
    opacity: 1;
    border: 1px solid #d0d0d0;
    border-radius: 4px;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #555555;
    line-height: 32px;
    text-align: center;
    cursor: pointer;
  }

  .archivesInfo-content {
    padding: 20px;
  }

  .archivesTable {
    line-height: 38px;
    text-align: left;
    font-size: 14px;
  }

  .archivesTable td {
    padding-left: 20px;
    border: 1px solid #efefef;
  }

  .archivesTd1 {
    height: 38px;
    background-color: #f6f6f6;
    width: 105px;

  }
</style>



// WEBPACK FOOTER //
// src/components/company/ArchivesInfo.vue